// extracted by mini-css-extract-plugin
module.exports = {"Avatar":"Avatar_Avatar__3RaPv","AvatarImg":"Avatar_AvatarImg__xkG_n"};